import { Link } from 'devextreme-react/sankey';
import { ToastBottomEnd } from "../../components/Toast";
import React, { useEffect, useState } from 'react'
import { verifyTokenExpire } from "../../../middleware/verifyToken";
import { useTranslation } from 'react-i18next';
import ls from "localstorage-slim";
import appConfig from '../../../config/appConfig'
import axios from 'axios';
import { AUTH_TOKEN } from '../../../constants/token';
import ListDiscussionBlock from './ListDiscussionBlock'
import MessageList from './MessageList'
import NoDiscussionSelected from './NoDiscussionSelected'
import EmptyMessage from './EmptyMessage'
import { now } from 'moment';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import EmptyDiscussion from './EmptyDiscussion';
import ChatLoader from './ChatLoader';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const SocialMedia = () => {
    //usage of useTranslation i18n
    const { t, ready } = useTranslation();

    const defaultData = {
        text: "",
        files: [],
        parent_id: "",
    };

    const defaultError = {
        text: "",
        files: [],
        parent_id: "",
    };

    const [data, setData] = useState(defaultData);
    const [load, setLoad] = useState(true);
    const [loadButton, setLoadButton] = useState(false);
    const [search, setSearch] = useState(false);
    const [listChat, setListChat] = useState([]);
    const [activeChat, setActiveChat] = useState(null);
    const [listChatMessages, setListChatMessage] = useState([]);
    const [idChat, setIdChat] = useState(null);

    const changeChat = (id) => {
        setActiveChat(id)
        setIdChat(id)
    }


    const onChangeText = (e) => {
        let newData = { ...data };
        newData.text = e.target.value;
        setData(newData);
    };

    const addItem = (e) => {
        e.preventDefault();
        axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
        
        if ((data.text !== "" && idChat)) {
            setLoadButton(true)
            if (verifyTokenExpire()) {
                axios
                .put(
                    appConfig.apiDomaine + `/social-network/discussions/${idChat}`,
                    {
                        message: data.text
                    }
                )
                .then((response) => {
                    listChat.map((chat) => {
                        if(chat.id==idChat) chat.messages.push({
                            type: 'out',
                            message: data.text,
                            created_at: now()
                        })
                    })
                    setIdChat(idChat);
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    setLoadButton(false)
                    setData(defaultData)
                });
                
            }
        }
    };

    const onChangeFile = (e) => {
        let newData = { ...data };
        newData.files = Object.values(e.target.files);
        setData(newData);
    };

    const responseToMessage = (id, text) => {
        const newData = { ...data };
        newData.parent_id = id;
        //setMessageTarget(text);
        setData(newData);
    };

    const closeTag = () => {
        const newData = { ...data };
        newData.parent_id = "";
        newData.files = "";
        //setMessageTarget("");
        setData(newData);
    };

    const loadDiscussion = (channel) => {
        const channelAutoriser = ['whatsapp','facebook','twitter','linkedin']

        if(channelAutoriser.includes(channel)) {
            if(channel=="facebook") channel="messenger"
        }

        setLoad(true)
        
        axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
        if(verifyTokenExpire()) {
            axios
            .get(
                appConfig.apiDomaine + `/social-network/discussions?channel=${channel}`
            )
            .then((response) => {
                if(response.data.length) {
                    setListChat(response.data);
                }
                setLoad(false);
            })
            .catch((error) => {
                setLoad(false);
            });
        }
    }

    const resetState = () => {
        setListChat([])
        setListChatMessage([])
        setIdChat(null)
        setActiveChat(null)
    }

    const {slug} = useParams()

    useEffect(()=>{
        loadDiscussion(slug)
    }, [])

    useEffect(()=>{
        if(idChat!=null) {
            listChat.map((chat) => {
                if(chat.id==idChat) setListChatMessage(chat.messages)
            })
        }
    }, [idChat])

    const location = useLocation()

    useEffect(()=>{
        const channel = location.pathname.split('/').at(-1)
        loadDiscussion(channel)
        resetState()
    }, [location.pathname])

    let userDataJson = JSON.parse(ls.get("userData"));
    

    return (
        <div
            className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
            id="kt_content"
        >
            <div className="kt-subheader   kt-grid__item" id="kt_subheader">
                <div className="kt-container  kt-container--fluid ">
                    <div className="kt-subheader__main">
                        
                        <h3 className="kt-subheader__title"> {t("Discussion")} </h3>
                        <span className="kt-subheader__separator kt-hidden" />
                        <div className="kt-subheader__breadcrumbs">
                            <a href="#icone" className="kt-subheader__breadcrumbs-home">
                                <i className="flaticon2-shelter" />
                            </a>
                            <span className="kt-subheader__breadcrumbs-separator" />
                            <a
                                href="#button"
                                onClick={(e) => e.preventDefault()}
                                className="kt-subheader__breadcrumbs-link"
                            >
                                {t("reseau")}
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                <div className="kt-grid kt-grid--desktop kt-grid--ver kt-grid--ver-desktop kt-app">
                    <div
                        className="kt-grid__item kt-app__toggle kt-app__aside kt-app__aside--lg kt-app__aside--fit"
                        id="kt_chat_aside"
                    >
                        <div className="kt-portlet kt-portlet--last">
                            <div className="kt-portlet__body">
                                {/*   RECHERCHE*/}
                                <div className="kt-searchbar">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="24px"
                                                height="24px"
                                                viewBox="0 0 24 24"
                                                version="1.1"
                                                className="kt-svg-icon"
                                                >
                                                <g
                                                    stroke="none"
                                                    strokeWidth="1"
                                                    fill="none"
                                                    fillRule="evenodd"
                                                >
                                                    <rect x="0" y="0" width="24" height="24"></rect>
                                                    <path
                                                    d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                                                    fill="#000000"
                                                    fillRule="nonzero"
                                                    opacity="0.3"
                                                    ></path>
                                                    <path
                                                    d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                                                    fill="#000000"
                                                    fillRule="nonzero"
                                                    ></path>
                                                </g>
                                                </svg>
                                            </span>
                                        </div>
                                        <input
                                            id="myInput"
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Search")}
                                            aria-controls="basic-addon1"
                                        />
                                    </div>
                                </div>

                                <div className="kt-widget kt-widget--users kt-mt-20">
                                    <div
                                        className="kt-scroll kt-scroll--pull ps--active-y"
                                        data-mobile-height="300"
                                        style={{ height: "400px", overflow: "scroll" }}
                                    >
                                        <ul id="myUL">
                                            {   load ? 
                                                    <ChatLoader />
                                                : 
                                                listChat.length ?
                                                    listChat.map((chat, i) => {
                                                    
                                                        return <ListDiscussionBlock 
                                                                    key={i} 
                                                                    numero={chat.external_client_id}
                                                                    lastMessage={chat.messages.at(-1).message}
                                                                    date={chat.updated_at}
                                                                    id={chat.id}
                                                                    activeChat={activeChat}
                                                                    changeChat={changeChat}
                                                                    isread={chat.is_read}
                                                                    channel={slug}
                                                                />
                                                    })
                                                : <EmptyDiscussion />
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="kt-grid__item kt-grid__item--fluid kt-app__content"
                        id="messageList"
                    >
                        <div className="kt-chat" id="kt-chat">
                            <div className="kt-portlet kt-portlet--head-lg- ">
                                <div className="kt-portlet__head">
                                    <div className="kt-chat__head ">
                                        <div className="kt-chat__left">
                                            <span></span>
                                        </div>
                                        <div className="kt-chat__center">
                                            <h5>{t("Discussions")}</h5>
                                        </div>
                                        <div className="kt-chat__right">
                                            <div className="dropdown dropdown-inline">
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="kt-portlet__body">
                                    <div
                                        className="kt-scroll kt-scroll--pull ps ps--active-y overflow-auto"
                                        id="kt-scroll"
                                        data-mobile-height="350"
                                        style={{ height: "250px", overflow: "auto" }}
                                    >
                                        <div className="message-list">
                                            {
                                                idChat ? listChatMessages.length ? (
                                                    listChatMessages.map((message,id) => {
                                                        return <MessageList 
                                                                    key={id}
                                                                    data={message}
                                                                />
                                                    })
                                                ) : (
                                                    <EmptyMessage />
                                                ) : (
                                                    <NoDiscussionSelected />
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="kt-portlet__foot position-relative">
                                    <div className="kt-chat__input">
                                        <input
                                            style={{ display: "none" }}
                                            id="parent_id"
                                            type="text"
                                            value={data.parent_id}
                                            onChange={responseToMessage}
                                        />

                                        <div className="kt-chat__editor">
                                        {data.parent_id ? (
                                            <div className="message_target">
                                                <i
                                                    className="d-flex justify-content-end flaticon-close"
                                                    onClick={(e) => closeTag(e)}
                                                ></i>
                                                <i className="la la-tags"></i>
                                                <br />
                                            </div>
                                        ) : (
                                            ""
                                        )}

                                        {/*data.files
                                            ? data.files.map((file, i) => (
                                                <div className="message_target" key={i}>
                                                <i
                                                    className="d-flex justify-content-end flaticon-close"
                                                    onClick={(e) => closeTag(e)}
                                                />
                                                <img
                                                    src="/assets/media/users/file-icon.png"
                                                    alt=""
                                                    style={{
                                                    maxWidth: "55px",
                                                    maxHeight: "55px",
                                                    }}
                                                />
                                                {file.name}
                                                </div>
                                            ))
                                            : ""*/}

                                            {
                                                activeChat && (
                                                    <textarea
                                                        id={"monChamp"}
                                                        style={{ height: "35px" }}
                                                        autoFocus={true}
                                                        placeholder="Votre message..."
                                                        value={data.text}
                                                        onChange={(e) => onChangeText(e)}
                                                    />
                                                )
                                            }
                                        </div>
                                        <div className="kt-chat__toolbar">
                                            {/*<div className="image-upload">
                                                <label
                                                    htmlFor="file-input"
                                                    data-toggle="kt-tooltip"
                                                    title={t("Ajouter un fichier")}
                                                >
                                                    <i className="fas fa-paperclip"></i>
                                                </label>
                                                <input
                                                    id="file-input"
                                                    type="file"
                                                    onChange={onChangeFile}
                                                    multiple={true}
                                                />
                                            </div>*/}

                                            <div className="kt_chat__actions">
                                                
                                                {activeChat && !loadButton && (
                                                    <button
                                                        type="button"
                                                        onClick={(e) => addItem(e)}
                                                        className="btn btn-brand btn-md btn-upper btn-bold kt-chat__reply "
                                                    >
                                                        {t("Envoyer")}
                                                    </button>
                                                )}
                                                {activeChat && loadButton && (
                                                    <button
                                                        className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light"
                                                        type="button"
                                                        disabled
                                                    >
                                                        {t("Chargement")}...
                                                    </button>
                                                )}
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SocialMedia